<template>
  <div class="stationery-header">
    <div class="stationery-info-search-container">
      <!-- 搜索框 -->
      <search
        class="stationery-search"
        placeholder="请输入文具名称"
        @search="stationerySearch"
      />
    </div>
    <div class="stationery-info-button-container">
      <button
        class="button add-stationery"
        @click="addStationeryDialogShow"
        v-hasPermi="'sc:schoolstationery:add'"
      >
        <i class="iconfont icon-add"></i>新增文具
      </button>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  components: {
    search,
  },
  data() {
    return {};
  },
  methods: {
    stationerySearch(e) {
      this.$emit("stationerySearch", e);
    },
    addStationeryDialogShow() {
      this.$emit("addStationeryShowChange", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./stationeryHeader.scss";
</style>